define(
	function() {
		// TODO: Call .noConflict(true) when we don't need global jQuery anymore.
		return window.jQuery;
	}
);
